export default function cookieBannerEs() {
  return window ? window.cookieBannerEs : '';
}
